import { render, staticRenderFns } from "./GalleryForm.vue?vue&type=template&id=35aca7da&scoped=true&"
import script from "./GalleryForm.vue?vue&type=script&lang=js&"
export * from "./GalleryForm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/forms.css?vue&type=style&index=0&id=35aca7da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aca7da",
  null
  
)

export default component.exports